import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from './AllProducts'
import Button from '../../components/Button'
import { useNavigate, useLocation } from 'react-router-dom'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { roundCurrency } from '../../utils'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { cashPayment } from '../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import customMainApi from '../../api/index'
import { Empty, DatePicker } from 'antd'

const { RangePicker } = DatePicker
const handleBusinessPartner = _.debounce((searchFunc, value) => {
	searchFunc(value)
}, 1000)

const UsersInvoices = () => {
	const location = useLocation()

	dayjs.extend(advancedFormat)
	dayjs.extend(customParseFormat)
	const query = new URLSearchParams(location.search)
	const CardCode = query.get('CardCode')

	const {
		setClient: setClientStore,
		setImei: setImeiStore,
		setCardCode: setCardCodeStore,
	} = cashPayment.actions
	const {
		client: clientStore,
		imei: imeiStore,
		cardCode: cardCodeStore,
	} = useSelector((state) => state.cashPayment)
	const dispatch = useDispatch()
	const startOfMonth = dayjs().startOf('month')
	const endOfMonth = dayjs().endOf('month')
	const startDateFormatted = startOfMonth.format('YYYY-MM-DD')
	const endDateFormatted = endOfMonth.format('YYYY-MM-DD')
	const dateFormat = 'YYYY-MM-DD'
	const [dateStart, setDateStart] = useState(
		dayjs().startOf('year').format(dateFormat),
	)
	const [dateEnd, setDateEnd] = useState(dayjs().format(dateFormat))
	const { getMe } = useSelector((state) => state.main)

	const navigation = useNavigate()
	const errorRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [clientLoading, setClientLoading] = useState(false)
	const [client, setClient] = useState(clientStore)
	const [clientCode, setClientCode] = useState(cardCodeStore)
	const [imeiClient, setImeiClient] = useState(imeiStore)
	const [product, setProduct] = useState('')
	const [data, setData] = useState([])
	const [currentPage, setCurrentPage] = useState(0)
	const [clientsData, setClientsData] = useState([])
	const [userFields, setUserFields] = useState([])

	const search = () => {
		setIsLoading(true)
		// `Invoices?$filter=CardCode eq '${CardCode}' and Cancelled eq 'tNO'&$select=DocEntry,DocNum,CardCode,CardName,DocDate,DocTotal,PaidToDate,DocumentLines,SalesPersonCode`,

		customFuncsApi
			.get('XsSql/getInvoices', {
				params: {
					// type: 'oneinst',
					$skip: currentPage,
					IntrSerial: imeiClient || undefined,
					CardCode: CardCode,
					// itemCode: product || undefined,
					date1: dateStart + 'T22:00:00.000Z',
					date2: dateEnd + 'T22:00:00.000Z',
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				const resData = res.data.value || []
				setData(resData)
				setIsLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	useEffect(() => {
		userFieldsFn()
	}, [])
	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	useEffect(() => {
		if (!client) {
			dispatch(setClientStore(client))
		}
	}, [client])

	useEffect(() => {
		search()
	}, [currentPage])

	// const viewItem = (v) => {
	// 	const queryParams = new URLSearchParams({
	// 		DocEntry: JSON.stringify(v.DocEntry),
	// 		state: JSON.stringify(v),
	// 	}).toString()
	// 	window.open(`/viewRecoveryItem?${queryParams}`, '_blank')
	// }

	// const viewItem = (v) => {
	// 	navigation(`/viewItem`, { state: v })
	// }

	// 	const viewItem = (v) => {
	//     const url = `/viewItem`;
	//     const state = v;
	//     const newWindow = window.open(url, '_blank');
	//     if (newWindow) {
	//         newWindow.onload = () => {
	//             newWindow.history.replaceState(state, '', url);
	//         };
	//     }
	// }

	const viewItem = (v) => {
		// getMe?.Department2.Name !== 'Scoring' ? Boolean(false) :
		const url = `/viewItem?data=${encodeURIComponent(JSON.stringify(v))}&DocEntry=${v.DocEntry}&notShow=${Boolean(true)}&CardCode=${CardCode}`
		window.open(url, '_blank')
	}

	const newDatas = () => {
		if (data.length >= 10) {
			setCurrentPage(currentPage + 10)
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldData = () => {
		if (data.oldPage < 0) {
			alert('boshqa malumot yoq')
		} else {
			setCurrentPage(currentPage - 10)
		}
	}

	const handleSearch = () => {
		search()
	}
	const onRangeChange = (dates, dateStrings) => {
		if (dates) {
			const start = dates[0]
			const end = dates[1]

			console.log(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
			setDateStart(start ? start.format('YYYY-MM-DD') : null)
			setDateEnd(end ? end.format('YYYY-MM-DD') : null)
		} else {
			console.log('Clear')
		}
	}

	return (
		<Layout>
			<AllProductsStyle>
				<div className="container">
					<p className="productTitle">История покупок</p>
					<div className="flex items-center justify-between items-center">
						<div className="flex items-center gap-10 mt-10">
							<input
								className={'border-[1px] border-[#d9d9d9"] p-2 rounded-md '}
								type="text"
								placeholder="Имеи"
								defaultValue={imeiClient}
								onChange={(v) => {
									setImeiClient(v.target.value)
									dispatch(setImeiStore(v.target.value))
								}}
							/>
							<div className="flex flex-col w-full">
								{/* <p className={'font-medium text-zinc-600 text-sm mb-1'}>Дата</p> */}
								<RangePicker
									value={[
										dateStart ? dayjs(dateStart, dateFormat) : null,
										dateEnd ? dayjs(dateEnd, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangeChange}
									className='border-[1px] border-[#DFE2E9"] p-2 rounded-md min-w-[240px] w-full '
								/>
							</div>
							{/*<input*/}
							{/*  className={'border-[1px] border-[#d9d9d9"] p-2 rounded-md '}*/}
							{/*  type="text"*/}
							{/*  placeholder="Товар"*/}
							{/*  defaultValue={product}*/}
							{/*  onChange={(v) => setProduct(v.target.value)}*/}
							{/*/>*/}
							<Button onClick={() => handleSearch()} isLoading={isLoading}>
								Поиск
							</Button>
						</div>
						{/* <Button
							className={'btn mt-10'}
							onClick={() => window.open('/createProducts-payment', '_blank')}
						>
							{'+ Добавить'}
						</Button> */}
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8 mt-10">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Код клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Имя Клиента
											</th>
											{/* <th scope="col" className="px-6 py-4">
												Кому принадлежит телефон
											</th>
											<th scope="col" className="px-6 py-4">
												Гарант
											</th> */}
											<th scope="col" className="px-6 py-4">
												IMEI
											</th>

											<th scope="col" className="px-6 py-4">
												Товар
											</th>
											{/* <th scope="col" className="px-6 py-4">
												Страница
											</th> */}
											<th scope="col" className="px-6 py-4">
												Аккаунт защиты
											</th>
											<th scope="col" className="px-6 py-4">
												Общая сумма
											</th>
											<th scope="col" className="px-6 py-4">
												Оплачено
											</th>
											<th scope="col" className="px-6 py-4">
												Остаток
											</th>
											<th scope="col" className="px-6 py-4">
												Дата продажи
											</th>
										</tr>
									</thead>
									<tbody>
										{data.length > 0 ? (
											data.map((v, i) => {
												const color =
													get(v, 'U_Color', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Color')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Color', '') === value.Value,
																)?.Description || ''
														: ''

												const memory =
													get(v, 'U_Memory', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Memory')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Memory', '') === value.Value,
																)?.Description || ''
														: ''

												const condition =
													get(v, 'U_Condition', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Condition')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Condition', '') === value.Value,
																)?.Description || ''
														: ''

												return (
													<tr
														key={i}
														onClick={() => viewItem(v)}
														className="bg-white border-b  hover:bg-gray-50 "
													>
														<td
															scope="row"
															className="px-6 py-4 font-medium text-gray-900 "
														>
															{get(v, 'CardCode', '-')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'CardName', '-')}
														</td>
														{/* <td className="px-6 py-4">
														{get(v, 'U_Owner', '-')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'U_Guarantor', '-')}
													</td> */}
														<td className="px-6 py-4">
															{get(v, 'IntrSerial', '-') !== null &&
															get(v, 'IntrSerial', '-').length > 6
																? get(v, 'IntrSerial', '-').slice(-6)
																: get(v, 'IntrSerial', '-')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'Dscription', '')} {color} {memory}{' '}
															{condition}
														</td>
														{/* <td className="px-6 py-4">
															{get(v, 'U_DaftarPage', '-')}
														</td>{' '} */}
														<td className="px-6 py-4">
															{get(v, 'U_Icloud', '-')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(roundCurrency(get(v, 'DocTotal', '-')))
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(get(v, 'PaidToDate', '-'))
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(
																	get(v, 'DocTotal', '-') -
																		get(v, 'PaidToDate', '-'),
																)
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{moment(get(v, 'DocDate', '-')).format(
																'DD-MM-YYYY',
															)}
														</td>
													</tr>
												)
											})
										) : (
											<tr>
												<td colSpan="10">
													<Empty
														description="Нет информации!"
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2 ">
									<Button
										disabled={currentPage === 0}
										className={'btn'}
										onClick={oldData}
									>
										{'<'}
									</Button>
									<p>{currentPage / 10 + 1 || 1}</p>
									<Button
										disabled={data.length < 10}
										className={'btn'}
										onClick={newDatas}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default UsersInvoices
